export default __webpack_public_path__ + "static/media/haxe.7a12066d.svg";